import { ActionButton, DocHead, Footer, Header, MobileWarning, TooltipContainer } from 'components';
import { useCalculator } from 'contexts/Calculator/Calculator';
import { getUrl } from 'helpers';
import { useEffect, useState } from 'react';
import Analyze from 'steps/Analyze';
import Finish from 'steps/Finish';
import Setup from 'steps/Setup';
import { DEFAULT_VALUES } from '../constants';

export default function App() {
    const [isStaging, setIsStaging] = useState(false);

    useEffect(() => {
        setIsStaging(window.location.hostname === 'staging.kromatic.com');
    }, []);
    const calculator = useCalculator();

    const resetButtonDisabled = !(
        calculator.variants.some(variant => variant.result || variant.sampleSize) ||
        calculator.confidenceLevel !== DEFAULT_VALUES.confidenceLevel ||
        calculator.distributionFunction !== DEFAULT_VALUES.distributionFunction ||
        calculator.goal !== DEFAULT_VALUES.goal ||
        calculator.name ||
        calculator.populationSize ||
        calculator.resultMaxValue ||
        calculator.resultMinValue ||
        calculator.targetMarginOfError !== DEFAULT_VALUES.targetMarginOfError ||
        calculator.threshold
    );

    return (
        <div className="d-flex flex-column min-vh-100" id="calculator">
            <DocHead isStaging={isStaging} />
            <Header />
            <MobileWarning minWidth={350}>
                <div className="calculator container col order-2 px-3 py-5">
                    <main role="main">
                        <div className="mb-3 text-end">
                            <ActionButton
                                aria-label="Reset experiment"
                                className="pdf-hide"
                                data-testid="reset-experiment-button"
                                disabled={resetButtonDisabled}
                                icon="reset"
                                label="Reset Experiment"
                                onClick={calculator.reset}
                            />
                        </div>
                        <Setup />
                        <Analyze />
                        <Finish />
                    </main>
                    <TooltipContainer />
                </div>
            </MobileWarning>
            <div className="order-2">
                <div className="pdf-hide">
                    <Footer />
                </div>
                <div className="pdf-show">
                    <div className="d-flex align-items-center gap-3">
                        <div>Powered by</div>
                        <div>
                            <picture>
                                <img alt="Kromatic logo" height={36} src={getUrl('/assets/kromatic-black.svg')} />
                            </picture>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

